import { all, takeLatest } from 'redux-saga/effects';

import { interventionActions } from '../index';
import addDocument from './addDocument';
import addNote from './addNote';
import addWorker from './addWorker';
import archiveThreadMessage from './archiveThreadMessage';
import createThread from './createThread';
import createThreadMessage from './createThreadMessage';
import deleteDocument from './deleteDocument';
import edit from './edit';
import getAll from './getAll';
import getAllThreads from './getAllThreads';
import getDetails from './getDetails';
import getDocuments from './getDocuments';
import getSearched from './getSearched';
import getStatusDateChanged from './getStatusDateChanged';
import markThreadMessageAsOpen from './markThreadMessageAsOpen';
import removeWorker from './removeWorker';
import updateNote from './updateNote';

const interventionSagas = all([
  takeLatest(interventionActions.removeWorkerRequest, removeWorker),
  takeLatest(interventionActions.addWorkerRequest, addWorker),
  takeLatest(interventionActions.addDocumentRequest, addDocument),
  takeLatest(interventionActions.deleteDocumentRequest, deleteDocument),
  takeLatest(interventionActions.editRequest, edit),
  takeLatest(interventionActions.getAllRequest, getAll),
  takeLatest(interventionActions.getDetailsRequest, getDetails),
  takeLatest(interventionActions.getSearchedInterventionRequest, getSearched),
  takeLatest(interventionActions.getDocumentsRequest, getDocuments),
  takeLatest(
    interventionActions.getStatusDateChangedRequest,
    getStatusDateChanged,
  ),
  takeLatest(
    interventionActions.archiveThreadMessageRequest,
    archiveThreadMessage,
  ),
  takeLatest(interventionActions.createThreadRequest, createThread),
  takeLatest(
    interventionActions.createThreadMessageRequest,
    createThreadMessage,
  ),
  takeLatest(interventionActions.getAllThreadsRequest, getAllThreads),
  takeLatest(
    interventionActions.markThreadMessageAsOpenRequest,
    markThreadMessageAsOpen,
  ),
  takeLatest(interventionActions.addNoteRequest, addNote),
  takeLatest(interventionActions.updateNoteRequest, updateNote),
]);

export default interventionSagas;
